import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PrivacyPage = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/site-settings`);
        setContent(response.data?.privacy_policy);
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const defaultContent = {
    title: "Privacy Policy",
    last_updated: new Date().toISOString().split('T')[0],
    content: `<h2>Information We Collect</h2>
<p>We collect information you provide directly to us when making bookings, registering for events, or contacting us.</p>

<h2>How We Use Your Information</h2>
<p>We use the information we collect to:</p>
<ul>
<li>Process your bookings and registrations</li>
<li>Send you confirmations and updates about your events</li>
<li>Respond to your inquiries</li>
<li>Improve our services</li>
</ul>

<h2>Information Sharing</h2>
<p>We do not sell or rent your personal information to third parties. We may share your information with service providers who assist us in operating our business.</p>

<h2>Data Security</h2>
<p>We implement appropriate security measures to protect your personal information.</p>

<h2>Contact Us</h2>
<p>If you have questions about this Privacy Policy, please contact us.</p>`
  };

  const policy = content || defaultContent;

  return (
    <main className="pt-20 min-h-screen bg-[#050505]" data-testid="privacy-page">
      <div className="container-luxury py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl font-['Playfair_Display'] font-bold text-[#F5F5F0] mb-4">
            {policy.title}
          </h1>
          <p className="text-[#A1A1AA] mb-8">
            Last updated: {policy.last_updated}
          </p>
          <div className="gold-divider mb-8" />
          
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : (
            <div 
              className="prose prose-invert max-w-none policy-content"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          )}
        </motion.div>
      </div>
      
      <style>{`
        .policy-content {
          color: #A1A1AA;
          line-height: 1.8;
        }
        .policy-content h2 {
          font-size: 1.5em;
          font-weight: bold;
          color: #F5F5F0;
          font-family: 'Playfair Display', serif;
          margin-top: 2em;
          margin-bottom: 0.5em;
        }
        .policy-content h3 {
          font-size: 1.25em;
          font-weight: bold;
          color: #D4AF37;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
        }
        .policy-content p {
          margin-bottom: 1em;
        }
        .policy-content ul, .policy-content ol {
          padding-left: 1.5em;
          margin-bottom: 1em;
        }
        .policy-content li {
          margin-bottom: 0.5em;
        }
        .policy-content a {
          color: #D4AF37;
          text-decoration: underline;
        }
      `}</style>
    </main>
  );
};

export default PrivacyPage;
